import React from 'react';
import { cn } from '@/lib/utils';

export const GlowButton = React.forwardRef(function GlowButton(
    { as: As = 'button', variant = 'primary', size = 'md', className = '', children, ...props }, ref
) {
    const sizes = {
        sm: 'px-4 py-2 text-xs',
        md: 'px-5 py-3 text-sm',
        lg: 'px-7 py-3.5 text-[14px]',
    };
    const variants = {
        primary: 'bg-la-text text-la-inverse hover:bg-white border border-transparent',
        ghost: 'bg-transparent text-la-text border border-white/15 hover:border-white/30 hover:bg-white/[0.03]',
        gold: 'bg-la-gold/95 text-la-inverse hover:bg-la-gold2 border border-la-gold/30',
        outline: 'bg-transparent text-la-text border border-la-gold/40 hover:border-la-gold/70 hover:bg-la-gold/[0.05]',
    };
    return (
        <As
            ref={ref}
            className={cn(
                'relative inline-flex items-center justify-center gap-2 rounded-la font-medium tracking-[0.02em]',
                'transition-[background-color,border-color,color,box-shadow,transform] duration-300',
                'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-la-gold/50',
                'hover:-translate-y-[1px] active:scale-[0.99] disabled:opacity-50 disabled:cursor-not-allowed',
                sizes[size], variants[variant], className,
            )}
            {...props}
        >
            <span className="relative inline-flex items-center gap-2">{children}</span>
        </As>
    );
});

export default GlowButton;
